import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, resolveDirective as _resolveDirective, withDirectives as _withDirectives, isRef as _isRef, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-18d85d98"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "screen-dialog"
};
const _hoisted_2 = {
  class: "main"
};
const _hoisted_3 = {
  class: "name"
};
const _hoisted_4 = {
  class: "tabs"
};
import MyTabs from './myTabs.vue';
import { Search } from '@element-plus/icons-vue';
import { inject, onMounted } from 'vue';
import { axiosInstanceAll } from '@/api/instance';
import { debounce } from '@/utils/tools';
import { vodPlusBaseUrl } from '@/utils';
export default /*#__PURE__*/_defineComponent({
  __name: 'screenDialog',
  props: {
    modelValue: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update:modelValue', 'onSearch'],

  setup(__props, {
    emit
  }) {
    const props = __props;
    const tabsList = ref([]);
    const filterParams = reactive({
      year: '',
      area: '',
      property: '',
      sorts: 0,
      search: ''
    });
    const loading = ref(false);
    const actionForm = reactive({
      dialogConfig: {
        title: '',
        // destroyOnClose: true,
        isShowFooter: false
      },
      close: () => {
        emit('update:modelValue', false);
      }
    });
    const onTabClick = debounce(item => {
      // console.log(item);
      const {
        objectKey: key
      } = item;
      filterParams[key] = item.value;
      emit('onSearch', filterParams);
    }, 300);
    const onSearch = debounce(() => {
      console.log(filterParams);
      emit('onSearch', filterParams);
    }, 300);

    const getSearchParams = async () => {
      loading.value = true;
      const {
        searchParmUrl
      } = currentParams.value;
      const res = await axiosInstanceAll({
        method: 'get',
        url: '/vodPlus' + searchParmUrl.replace(vodPlusBaseUrl, ''),
        params: {
          usertoken: sessionStorage.getItem('vodPlusToken')
        }
      });
      console.log(res);

      if (res.status == 200) {
        tabsList.value = res.data;
      }

      loading.value = false;
    };

    const currentUiStyleOptions = inject('currentUiStyleOptions');
    const currentParams = inject('currentParams'); // watch(() => props.modelValue, (val) => {
    //     if (val) {
    //         getSearchParams()
    //     }
    // })

    onMounted(() => {
      getSearchParams();
    });
    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");

      const _component_el_input = _resolveComponent("el-input");

      const _component_m_dialog = _resolveComponent("m-dialog");

      const _directive_loading = _resolveDirective("loading");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_m_dialog, {
        modelValue: __props.modelValue,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _isRef(modelValue) ? modelValue.value = $event : null),
        nativeConfig: {
          top: '30vh',
          closeOnClickModal: false
        },
        "dialog-config": actionForm.dialogConfig,
        onOnClose: actionForm.close
      }, {
        default: _withCtx(() => [_withDirectives((_openBlock(), _createElementBlock("div", _hoisted_2, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tabsList.value, (item, index) => {
          return _openBlock(), _createElementBlock("div", {
            class: "tabs-item",
            key: index
          }, [_createElementVNode("span", _hoisted_3, _toDisplayString(item.name), 1), _createElementVNode("div", _hoisted_4, [__props.modelValue ? (_openBlock(), _createBlock(MyTabs, {
            key: 0,
            onOnTabClick: _unref(onTabClick),
            currentActive: filterParams[item.name],
            objectKey: item.name,
            tabKey: "key",
            tabValue: "value",
            tabLists: item.list
          }, null, 8, ["onOnTabClick", "currentActive", "objectKey", "tabLists"])) : _createCommentVNode("", true)])]);
        }), 128)), _createVNode(_component_el_input, {
          modelValue: filterParams.search,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => filterParams.search = $event),
          placeholder: _ctx.$t('请输入关键字')
        }, {
          append: _withCtx(() => [_createVNode(_component_el_button, {
            icon: _unref(Search),
            onClick: _unref(onSearch)
          }, null, 8, ["icon", "onClick"])]),
          _: 1
        }, 8, ["modelValue", "placeholder"])])), [[_directive_loading, loading.value]])]),
        _: 1
      }, 8, ["modelValue", "dialog-config", "onOnClose"])]);
    };
  }

});